/* eslint-disable no-useless-escape */
import React, { useCallback, useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
import { Form, Formik } from "formik";
import { pathOr } from "ramda";
import Checkbox from "antd/lib/checkbox/Checkbox";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

import UserService from "../../service/UserService";
import notificationService from "../../service/NotificationService";
import loginService from "../../service/login";
import { LoginSagaAction, checkUserExist } from "../../sagas/saga-actions";
import { setPopup } from "../../actions/popupAction";
import CustomButton from "../../components/customButton";
import Banner from "../../components/banner";
import CustomInput from "../../components/customInput";
import LoginNotification from "../../components/loginNotification";
import CustomNotification from "../notification";
import LoginLeftSection from "../loginLeftSection";
import { hasToken, hasMsInfoToken } from "../../helper/helpers";
import MFA from "./MFA";

import { usernameRegex } from "../../constants/constants";
import "./styles.scss";
import { EHR_NAME } from "../../constants/constants";

const LOGIN_NOTIFICATION_DISMISS_KEY = "notifications-public";
const BANNER_TYPE_ORDER = ["warning", "informational", "promotional"];

const Login = (props) => {
  const cookies = new Cookies();
  const userservice = new UserService();
  const dispatch = useDispatch();
  const history = useHistory();

  const [state, setState] = useState({
    loading: false,
    username: "",
    password: "",
    showOtp: false,
    otpValue: "",
    rememberMe: false,
    showMFA: false,
    phoneNumber: "",
    otpToken: "",
    email: "",
    errorMessage: "",
    loginBanners: [],
    loginNotifications: [],
    initialValuesLogin: {
      username: "",
      password: "",
    },
  });

  const { customPopupMessage, messageType, message } = props.popupReducer;

  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const credentialSchema = Yup.object().shape({
    username: Yup.string()
      .required("Username is required")
      .min(3, "Username must be at least 3 characters")
      .max(60, "Username must be less than 60 characters")
      .test(
        "test-username",
        "Please use correct format for Username",
        (value) => {
          const isValidEmail = emailRegex.test(value);
          const isValidUsername = usernameRegex.test(value);
          if (value && !isValidEmail && !isValidUsername) {
            return false;
          }
          return true;
        }
      ),

    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .max(60, "Password must be maximum 60 characters"),
  });

  const handleLogin = async (values, e) => {
    e.preventDefault();

    try {
      const userData = await userservice.loginUser(
        values?.username,
        values?.password
      );

      if (userData?.data?.success) {
        const {
          data: {
            otpChannel: { phone: phoneNumber = "", email = "" } = {},
            otpToken = "",
          } = {},
        } = userData;
        // set cookie
        userservice.setToken(otpToken);

        setState((st) => ({
          ...st,
          showMFA: true,
          phoneNumber,
          email,
          otpToken,
          errorMessage: "", // clear error on success
          otpState: {
            username: values.username,
            password: values.password,
            rememberMe: state.rememberMe,
          },
        }));
      }
    } catch (err) {
      if (err?.response?.data?.resetToken) {
        history.push({
          pathname: "/setpassword",
          search: `?${err?.response?.data?.resetToken}`,
        });
      }

      const message = pathOr(
        "Something went wrong",
        ["response", "data", "message"],
        err
      );

      setState((st) => ({
        ...st,
        errorMessage: message,
      }));
    }
  };

  const handleMsLogin = useCallback(async () => {
    try {
      if (hasToken()) {
        history.push("/chat");
        return;
      }
      const loginUrl = await userservice.getMsLoginUrl();
      window.location.href = loginUrl;
    } catch (e) {
      dispatch(
        setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: pathOr(
            "Something went wrong",
            ["response", "data", "message"],
            e
          ),
        })
      );
    }
  }, []);

  const handleRememberMe = async (e) => {
    try {
      setState((st) => ({
        ...st,
        rememberMe: e,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleForgetPassword = () => {
    history.push("/forgetpassword");
  };

  const checkLogin = async () => {
    if (loginService.isLoggedin()) {
      history.push("/chat");
    }

    if (cookies.get("username") && cookies.get("password")) {
      setState((st) => ({
        ...st,
        initialValuesLogin: {
          username: cookies.get("username"),
          password: cookies.get("password"),
        },
        isInitialValid: true,
        rememberMe: true,
      }));
    }
  };

  const redirectMs = () => {
    if (hasToken()) {
      const { payload: userDetails } = loginService.getDecodedToken();
      props.LoginSagaAction(userDetails);
      if (!userDetails.practiceId) {
        props.setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: `Invalid credentials!`,
        });
      } else {
        history.push("/chat");
        props.setPopup({
          customPopupMessage: true,
          messageType: "success",
          message: `${userDetails.name} logged in Successfully`,
        });
      }
    }

    const message = hasMsInfoToken();
    if (message) {
      props.setPopup({
        customPopupMessage: true,
        messageType: "error",
        message: `${message}`,
      });
    }
  };

  useEffect(() => {
    checkLogin();
  }, []);

  useEffect(() => {
    redirectMs();
  }, []);

  useEffect(() => {
    let isMounted = true;

    const getNotifications = (payload) => {
      if (Array.isArray(payload)) {
        return payload;
      }
      if (Array.isArray(payload?.notifications)) {
        return payload.notifications;
      }
      return [];
    };

    const fetchLoginNotifications = async () => {
      try {
        const data = await notificationService.getActiveNotifications();
        const dismissedIds = JSON.parse(
          localStorage.getItem(LOGIN_NOTIFICATION_DISMISS_KEY) || "[]"
        );
        const notifications = getNotifications(data);
        const loginBanners = notifications
          .filter((notification) => {
            return (
              notification?.displayLoginPage &&
              notification?.notificationStyle === "banner" &&
              !dismissedIds.includes(notification?.id)
            );
          })
          .sort((a, b) => {
            return (
              BANNER_TYPE_ORDER.indexOf(a?.notificationType) -
              BANNER_TYPE_ORDER.indexOf(b?.notificationType)
            );
          });
        const loginNotifications = notifications
          .filter((notification) => {
            return (
              notification?.displayLoginPage &&
              notification?.notificationStyle === "notification" &&
              !dismissedIds.includes(notification?.id)
            );
          })
          .sort((a, b) => {
            return (
              BANNER_TYPE_ORDER.indexOf(a?.notificationType) -
              BANNER_TYPE_ORDER.indexOf(b?.notificationType)
            );
          });

        if (isMounted) {
          setState((st) => ({
            ...st,
            loginBanners,
            loginNotifications,
          }));
        }
      } catch (error) {
        if (isMounted) {
          setState((st) => ({
            ...st,
            loginBanners: [],
            loginNotifications: [],
          }));
        }
      }
    };

    fetchLoginNotifications();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div data-testid="login-page-wrapper" className="login-page-wrapper">
      {customPopupMessage && (
        <CustomNotification messageType={messageType} message={message} />
      )}
      {state.loginBanners.map((banner) => (
        <Banner
          key={banner?.id}
          notificationType={banner?.notificationType}
          displayMessage={banner?.displayMessage || banner?.displayTitle}
          canDismiss={banner?.canDismiss}
          link={banner?.link}
          onClose={() => {
            const dismissedIds = JSON.parse(
              localStorage.getItem(LOGIN_NOTIFICATION_DISMISS_KEY) || "[]"
            );
            if (!dismissedIds.includes(banner?.id)) {
              localStorage.setItem(
                LOGIN_NOTIFICATION_DISMISS_KEY,
                JSON.stringify([...dismissedIds, banner?.id])
              );
            }
            setState((st) => ({
              ...st,
              loginBanners: st.loginBanners.filter(
                (item) => item?.id !== banner?.id
              ),
            }));
          }}
        />
      ))}
      {!!state.loginNotifications.length && (
        <div className="login-page-notification-stack">
          {state.loginNotifications.map((notification) => (
            <LoginNotification
              key={notification?.id}
              notificationType={notification?.notificationType}
              displayTitle={notification?.displayTitle}
              displayMessage={notification?.displayMessage}
              notificationImage={notification?.notificationImage}
              link={notification?.link}
              onClose={() => {
                const dismissedIds = JSON.parse(
                  localStorage.getItem(LOGIN_NOTIFICATION_DISMISS_KEY) || "[]"
                );
                if (!dismissedIds.includes(notification?.id)) {
                  localStorage.setItem(
                    LOGIN_NOTIFICATION_DISMISS_KEY,
                    JSON.stringify([...dismissedIds, notification?.id])
                  );
                }
                setState((st) => ({
                  ...st,
                  loginNotifications: st.loginNotifications.filter(
                    (item) => item?.id !== notification?.id
                  ),
                }));
              }}
            />
          ))}
        </div>
      )}
      <main className="login-page-main">
        <LoginLeftSection />

        {state.showMFA ? (
          <section className="form-wrapper">
            <MFA
              history={history}
              otpState={state.otpState}
              onBack={() => {
                setState((st) => ({
                  ...st,
                  showMFA: false,
                  phoneNumber: "",
                  email: "",
                  otpState: {},
                }));
              }}
              phoneNumber={state.phoneNumber}
              email={state.email}
              otpToken={state.otpToken}
            />
          </section>
        ) : (
          <section className="form-wrapper">
            <h2 className="form-heading">LOGIN TO LIVE CHAT</h2>
            <p className="form-caption">Please login to access your account.</p>
            <Formik
              enableReinitialize
              initialValues={state?.initialValuesLogin}
              validationSchema={credentialSchema}
              validateOnMount
              isInitialValid={!!state?.isInitialValid}
            >
              {({
                isValid,
                values,
                dirty,
                errors,
                setFieldTouched,
                setFieldValue,
              }) => {
                return (
                  <Form
                    className="login-form"
                    onSubmit={(e) => handleLogin(values, e)}
                  >
                    <section className="custom-input-group name-field">
                      <label className="input-label">Username</label>
                      <CustomInput
                        className={"custom-form-input"}
                        placeholder="Enter username..."
                        name="username"
                        onChange={(e) => {
                          const value = e.target.value;
                          setFieldTouched("username", true);
                          setFieldValue("username", value);
                          setState((st) => ({
                            ...st,
                            errorMessage: "", // Clear error when typing
                          }));
                        }}
                        maxLength={60}
                      />
                    </section>

                    <section className="custom-input-group password-field">
                      <label className="input-label">Password</label>
                      <CustomInput
                        type="password"
                        name="password"
                        className="custom-form-password"
                        autoComplete="new-password"
                        maxLength={60}
                        onChange={(e) => {
                          const value = e.target.value;
                          setFieldTouched("password", true);
                          setFieldValue("password", value);
                          setState((st) => ({
                            ...st,
                            errorMessage: "", // Clear error when typing
                          }));
                        }}
                        theme={EHR_NAME}
                      />
                      {state.errorMessage && (
                        <div className="login-error-message">
                          {state.errorMessage}
                        </div>
                      )}
                    </section>

                    <section className="login-options">
                      <Checkbox
                        onChange={(e) => handleRememberMe(e?.target?.checked)}
                        checked={state.rememberMe}
                      >
                        <span className="remember-me">Remember me</span>
                      </Checkbox>

                      <div
                        onClick={handleForgetPassword}
                        className="login-link"
                      >
                        Forgot Password?
                      </div>
                    </section>

                    <section className="login-options">
                      <CustomButton
                        htmlType="submit"
                        type="primary"
                        className={!isValid ? "disable-button" : ""}
                        disabled={!isValid}
                        title="Login"
                      />
                    </section>

                    <h2 className="divider-heading">
                      <span className="divider-details">OR</span>
                    </h2>
                  </Form>
                );
              }}
            </Formik>

            <button className="login-with-ms-button">
              <article className="login-with-microsoft">
                <div className="logo">
                  <span className="red logo-color" />
                  <span className="green logo-color" />
                  <span className="blue logo-color" />
                  <span className="yellow logo-color" />
                </div>
                <span className="heading ml-8" onClick={(e) => handleMsLogin()}>
                  Login with Microsoft Account
                </span>
              </article>
            </button>
          </section>
        )}
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    popupReducer: state.popupReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    LoginSagaAction: (data) => {
      dispatch(LoginSagaAction(data));
    },
    checkUserExist: (data) => dispatch(checkUserExist(data)),
    setPopup: (data) => dispatch(setPopup(data)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Login)
);
